/* istanbul ignore file */
import React from 'react';
import { useParams } from 'react-router-dom';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import ContractsBreadcrumbs from 'domain/people/contracts/shared/ContractsBreadcrumbs';
import { useContractsUrl } from 'domain/people/contracts/contractsRouting';

const SingleContractsBreadcrumbs = ({ children = null }: { children?: React.ReactNode }) => {
  const { getSingleEntityUrl } = useContractsUrl();
  const { id } = useParams<any>();

  return (
    <ContractsBreadcrumbs>
      <SingleBreadcrumbItem entity={id!} link={getSingleEntityUrl(id)} />
      {children}
    </ContractsBreadcrumbs>
  );
};

export default SingleContractsBreadcrumbs;
